import { render, staticRenderFns } from "./scoringRubric.vue?vue&type=template&id=9ecca4f2&scoped=true"
import script from "./scoringRubric.vue?vue&type=script&lang=js"
export * from "./scoringRubric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecca4f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ecca4f2')) {
      api.createRecord('9ecca4f2', component.options)
    } else {
      api.reload('9ecca4f2', component.options)
    }
    module.hot.accept("./scoringRubric.vue?vue&type=template&id=9ecca4f2&scoped=true", function () {
      api.rerender('9ecca4f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/AAA/dialog/scoringRubric.vue"
export default component.exports